// ═══════════════════════════════════════════════════════════════════════════
// PAYVIT LOGO
//
// `LOGO_SRC` is same-origin ON PURPOSE. The production build makes zero
// external network requests, which keeps the page fast on Haitian mobile data
// and keeps the Content-Security-Policy tight (no third-party image host to
// allow-list, no imgur outage taking the splash screen down).
//
// ▶ BEFORE YOU DEPLOY: save the real asset to `public/logo.png`.
//   The source file is https://i.imgur.com/Tob80xG.png — download it once and
//   drop it in. `npm run build` copies everything in public/ into dist/.
//
// If the file is missing, `onError` falls back to the traced path below so the
// splash screen is never blank. The fallback is the same geometry, not a
// substitute mark — but it is a trace, so ship the real PNG.
// ═══════════════════════════════════════════════════════════════════════════
import * as React from "react"
import { SITE_BG } from "./tokens"

export const LOGO_SRC = "/logo.png"
export const LOGO_TEAL = "#31D3BC"

export function PayvitLogo({
    size = 24,
    fill = LOGO_TEAL,
    eye = SITE_BG,
}: {
    size?: number
    fill?: string
    eye?: string
}) {
    const [failed, setFailed] = React.useState(false)

    if (!failed) {
        return (
            <img
                src={LOGO_SRC}
                alt="Payvit"
                width={size}
                height={size}
                onError={() => setFailed(true)}
                /* Square box, aspect ratio preserved inside it — the asset is
                   never stretched to fill. */
                style={{ width: size, height: size, objectFit: "contain", display: "block" }}
            />
        )
    }

    return (
        <svg width={size} height={size} viewBox="0 0 500 500" fill="none" role="img" aria-label="Payvit">
            <g transform="translate(25, 25)">
                <path
                    d="M 17,25
                       L 334,25
                       L 423,172
                       L 334,319
                       L 245,319
                       L 165,425
                       L 17,425
                       L 160,283
                       Q 166,277 160,271
                       L 17,149
                       L 160,217
                       Q 166,220 162,213
                       Z"
                    fill={fill}
                />
                <circle cx="304" cy="99" r="23" fill={eye} />
            </g>
        </svg>
    )
}
